// Angular imports
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';

// Rxjs imports
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// Service imports
import { AuthService } from '../_services/auth.service';
import { RoutingHelperService } from '../_services/shared-services/routing-helper.service';

@Injectable({
    providedIn: 'root'
})
export class DataGuard implements CanActivate {
    previousURL: string;
    routed = false;
    allowAnonymous = false;
    outletOnly = false;

    constructor(
        private readonly authService: AuthService,
        private readonly routingHelperService: RoutingHelperService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (route.data.anonymousAccess) {
            this.routingHelperService.setAllowAnonymous(route.data.anonymousAccess);
        }

        if (route.data.outletOnly) {
            this.routingHelperService.setOutletOnly(route.data.outletOnly);
        }

        const userLoggedIn = this.authService.isLoggedIn;
        if (!userLoggedIn && this.authService.hasFormsAuthenticationCookie) {
            return this.authService.loginUsingFormsAuthentication().pipe(
                map(() => {
                    // NOTE: This is not an authentication guard. It does not matter if login using forms authentication was successful or not.
                    return true;
                }),
                catchError(() => {
                    return of(true);
                })
            );
        } else {
            return true;
        }
    }
}
